import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";
import brandTheme from "brandTheme/Theme.js";
import ApplicantNew from "./ApplicantNew";
import ApplicantBT from "./ApplicantBT";
import ApplicantPostAndRePledge from "./ApplicantPostAndRePledge";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import { useSelector } from "react-redux";
import { parseAndSetFlag } from "utils/Utils";
import { aadharVendor } from "assets/properties/properties";
import { vendorNameList } from "assets/properties/properties";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
const styles = () => ({
  validateButton: {
    position: "absolute",
    top: 0,
    right: 0,
    padding: "11px 15px",
    margin: 0,
  },
  addressContainer: {
    display: "flex",
    alignItems: "center",
    textAlign: "left",
    margin: "2% 0 0 1%",
    "@media (max-width:520px)": {
      flexDirection: "column",
      marginTop: "20px",
    },
  },
  nextButton: { backgroundColor: brandTheme.buttonColor },
});
const Applicant = ({
  setBack,
  classes,
  setNext,
  loanApplicationId,
  loanApplicationNumber,
  PanNumberObj,
  editable,
  status,
  onNewCustomer,
  documentLink,
  setDetailsss,
  subStatus,
  loanType,
  mobileNum,
  PanNameObj,
  loanAccountNumber,
  featureFlags,
  firstTab,
  existingLoanData,
  actualLoanAmount,
}) => {
  const [panThirdPartyPanEnabled, setThirdPartyPanEnabled]=useState(false);
  const [aadharThirdPartyAadharEnabled, setThirdPartyAadharEnabled]=useState(false);
  const { authToken } = useSelector((state) => state.login.authData);
  const [aadharVendorThirdParty, setAadharVendor] = useState(null);
  const outletData = featureFlags;
 const aadharIntegrationListFlag = JSON.parse(outletData?.aadharIntegrationListFlag || "[]");
  const disbaledAddharFlag = parseAndSetFlag(outletData?.hideSwitchForAadharApplicantPageFlag);
  const enabledReKycForDocumentVerification = parseAndSetFlag(outletData?.enabledReKycForDocumentVerification);
  const enabledFieldsForApplciantPage = parseAndSetFlag(outletData?.enabledFieldsForApplciantPage);
  const applicantDetailsReverifyAadhar = parseAndSetFlag(outletData?.applicantDetailsReverifyAadhar);
  const enabledManualOcrSelect = parseAndSetFlag(outletData?.enabledManualOcrSelect);
  const enbaledAddharListFromFlag = parseAndSetFlag(outletData?.enbaledAddharListFromFlag);
   const [aadharIntegrationOptions, setAadharIntegrationOptions] = useState(aadharIntegrationListFlag);
   const [callInProgress, setCallInProgress] = useState(false);
 const GetThirdPartyData = async () => {
  setCallInProgress(true);
  const result = await apiHandler({
    url: endpoint.CHECK_THIRD_PARTY_INTEGRATION,
    authToken: authToken,
  });
  setCallInProgress(false);
  if (Array.isArray(result?.data)) {
    const panIntegration = result.data.find(
      (integration) => integration?.integration === "PAN"
    );
    const aadharIntegration = result.data.find(
      (integration) => integration?.integration === "ADHAAR"
    );
    const isPanEnabled = panIntegration?.enabled || false;
    const isAadharEnabled = aadharIntegration?.enabled || false;
    const aadharVendorThirdParty = aadharIntegration?.vendor || null;

    setThirdPartyPanEnabled(isPanEnabled);
    setThirdPartyAadharEnabled(isAadharEnabled);
    setAadharVendor(aadharVendorThirdParty);
        if (disbaledAddharFlag) {
          if (isAadharEnabled) {
            if (aadharVendorThirdParty === aadharVendor?.authBridgeOCR) {    
              setAadharIntegrationOptions([    
                { code: aadharVendor?.authBridgeOCR, name: vendorNameList?.ocr },    
              ]);
            } else {
              const updatedOptions = [];
              const vendorOption = aadharIntegrationListFlag.find(
                (item) => item.code === aadharVendorThirdParty
              );
              if (vendorOption) {
                updatedOptions.push(vendorOption);
              }
              if(enabledManualOcrSelect || aadharVendorThirdParty === aadharVendor?.authBridgeDigiLocker ){
              updatedOptions.push({ code: aadharVendor?.authBridgeOCR, name: vendorNameList?.ocr });}
              setAadharIntegrationOptions(updatedOptions);
            }
          } else {
            setAadharIntegrationOptions([
              { code: aadharVendor?.manual, name: vendorNameList?.manual },
              { code: aadharVendor?.authBridgeOCR, name: vendorNameList?.ocr },
            ]);
          }
        }else{
          const updatedOptions = [];
          if(enbaledAddharListFromFlag){
            setAadharIntegrationOptions(aadharIntegrationListFlag);
          }else{
            if(isAadharEnabled){
              const vendorOption = aadharIntegrationListFlag.find(
                (item) => item.code === aadharVendorThirdParty
              );
              if (vendorOption) {
                updatedOptions.push(vendorOption);
              }
            }
            updatedOptions.push({ code: aadharVendor?.smcAuthBridgeOCR, name: vendorNameList?.ocr })
            setAadharIntegrationOptions(updatedOptions);
          }
        }
  } else {
    setThirdPartyPanEnabled(false);
    setThirdPartyAadharEnabled(false);
    setAadharVendor(null);
  }
};
  useEffect(()=>{
    GetThirdPartyData()
  },[])
  if(callInProgress){
  return <CircularProgresss callInProgress={callInProgress}/>
  }
  if(applicantDetailsReverifyAadhar){
    return (
      <ApplicantNew
      classes={classes}
      status={status}
      loanApplicationId={loanApplicationId}
      loanApplicationNumber={loanApplicationNumber}
      setNext={setNext}
      setBack={setBack}
      PanNameObj={PanNameObj}
      editable={editable}
      PanNumberObj={PanNumberObj}
      onNewCustomer={onNewCustomer}
      documentLink={documentLink}
      setDetailsss={setDetailsss}
      mobileNum={mobileNum}
      loanAccountNumber={loanAccountNumber}
      panThirdPartyPanEnabled={panThirdPartyPanEnabled}
      aadharThirdPartyAadharEnabled={aadharThirdPartyAadharEnabled}
      aadharVendorThirdParty={aadharVendorThirdParty}
      aadharIntegrationOptions={aadharIntegrationOptions}
      featureFlags={featureFlags}
      firstTab={firstTab}
      existingLoanData={existingLoanData}
      enabledFieldsForApplciantPage={enabledFieldsForApplciantPage}
      subStatus={subStatus}
      applicantDetailsReverifyAadhar={applicantDetailsReverifyAadhar}
      actualLoanAmountForProcessingFee={actualLoanAmount}
      />
    )
  }
  if (subStatus === "PRE_PLEDGE") {
    return (
      <ApplicantBT
        classes={classes}
        status={status}
        loanApplicationId={loanApplicationId}
        loanApplicationNumber={loanApplicationNumber}
        setNext={setNext}
        setBack={setBack}
        editable={editable}
        PanNumberObj={PanNumberObj}
        PanNameObj={PanNameObj}
        onNewCustomer={onNewCustomer}
        documentLink={documentLink}
        setDetailsss={setDetailsss}
        mobileNum={mobileNum}
        loanAccountNumber={loanAccountNumber}
        panThirdPartyPanEnabled={panThirdPartyPanEnabled}
        aadharThirdPartyAadharEnabled={aadharThirdPartyAadharEnabled}
        aadharVendorThirdParty={aadharVendorThirdParty}
        aadharIntegrationOptions={aadharIntegrationOptions}
        featureFlags={featureFlags}
        firstTab={firstTab}
        existingLoanData={existingLoanData}
        subStatus={subStatus}
        enabledFieldsForApplciantPage={enabledFieldsForApplciantPage}
        actualLoanAmountForProcessingFee={actualLoanAmount}
      />
    );
  }
  return (subStatus === "POST_PLEDGE" || loanType === "RE_PLEDGE") && !enabledReKycForDocumentVerification ? (
    <ApplicantPostAndRePledge
      classes={classes}
      PanNameObj={PanNameObj}
      status={status}
      loanApplicationId={loanApplicationId}
      loanApplicationNumber={loanApplicationNumber}
      setNext={setNext}
      setBack={setBack}
      editable={editable}
      PanNumberObj={PanNumberObj}
      onNewCustomer={onNewCustomer}
      documentLink={documentLink}
      setDetailsss={setDetailsss}
      mobileNum={mobileNum}
      loanAccountNumber={loanAccountNumber}
      loanType={loanType}
      panThirdPartyPanEnabled={panThirdPartyPanEnabled}
      aadharThirdPartyAadharEnabled={aadharThirdPartyAadharEnabled}
      aadharVendorThirdParty={aadharVendorThirdParty}
      featureFlags={featureFlags}
      firstTab={firstTab}
      existingLoanData={existingLoanData}
      subStatus={subStatus}
      enabledFieldsForApplciantPage={enabledFieldsForApplciantPage}
      aadharIntegrationOptions={aadharIntegrationOptions}
      actualLoanAmountForProcessingFee={actualLoanAmount}
    />
  ) : (
    <ApplicantNew
      classes={classes}
      status={status}
      loanApplicationId={loanApplicationId}
      loanApplicationNumber={loanApplicationNumber}
      setNext={setNext}
      setBack={setBack}
      PanNameObj={PanNameObj}
      editable={editable}
      PanNumberObj={PanNumberObj}
      onNewCustomer={onNewCustomer}
      documentLink={documentLink}
      setDetailsss={setDetailsss}
      mobileNum={mobileNum}
      loanAccountNumber={loanAccountNumber}
      panThirdPartyPanEnabled={panThirdPartyPanEnabled}
      aadharThirdPartyAadharEnabled={aadharThirdPartyAadharEnabled}
      aadharVendorThirdParty={aadharVendorThirdParty}
      aadharIntegrationOptions={aadharIntegrationOptions}
      featureFlags={featureFlags}
      firstTab={firstTab}
      existingLoanData={existingLoanData}
      enabledFieldsForApplciantPage={enabledFieldsForApplciantPage}
      subStatus={subStatus}
      actualLoanAmountForProcessingFee={actualLoanAmount}
    />
  );
};
Applicant.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
  loanApplicationNumber: PropTypes.object,
  editable: PropTypes.object,
};

export default withStyles(styles)(Applicant);
